<template>
  <div class="corpo-pagina">
    <div class="row row-text">
      <div class="col s12">
        <h4>{{ traduzione('pagina.carrello.titolo') }}</h4>
      </div>
    </div>
    <div class="divider"></div>

    <div class="row">
      <div class="col s12">

        <div v-if="cartItems.length === 0" class="empty-cart-message center-align">
          <div v-if="pageNoitem">
            <i class="material-icons large grey-text text-lighten-2">remove_shopping_cart</i>
            <p class="flow-text">{{ traduzione('pagina.carrello.vuoto') }}</p>
             <router-link to="/pricing" class="btn-large">
                 {{ traduzione('pagina.prezzi.esplora') }}
          </router-link>
          </div>

          <div v-else>
            <i class="material-icons large green-text text-accent-4">check_circle</i>
            <p class="flow-text">{{ traduzione('pagina.pagamento.paypal.006') }}</p>
            <p class="flow-text">
              **{{ traduzione('pagina.payment.reindirizzamento.001') }} {{ countdown }} {{ traduzione('pagina.payment.reindirizzamento.002') }}...**
            </p>
             <router-link to="/list-events" class="btn-large">
            {{ traduzione('title.list.event.page') }}
          </router-link>
          </div>

        </div>

        <div v-else>
          <div class="row cart-checkout-layout">

            <div class="col s12 m5">
              <ul class="collection with-header">
                <li class="collection-header">
                  <h4>{{ traduzione('pagina.carrello.articoli') }} ({{ cartItems.length }})</h4>
                </li>

                <li v-for="item in cartItems" :key="item.uid" class="collection-item cart-item-list">
                  <div class="row valign-wrapper" style="margin-bottom: 0;">

                    <div class="col s10 m8">
                      <h5 class="item-name">{{ item.name }}</h5>
                      <p class="item-quantity">
                        {{ traduzione('pagina.prezzi.include') }}:
                        **{{ item.quantity.toLocaleString(currentLocale) }} {{ getTypeSuffix(item.type.name) }}**
                      </p>
                    </div>

                    <div class="col s2 m2 item-price right-align hide-on-small-only">
                      <span class="price-display">{{ formatCurrency(item.price) }}</span>
                    </div>

                    <div class="col s2 m2 right-align">
                      <a href="#!" class="secondary-content remove-btn" @click.prevent="removeItem(item.uid)">
                        <i class="material-icons red-text">delete</i>
                      </a>
                    </div>

                    <div class="col s12 item-price hide-on-med-and-up right-align" style="padding-top: 5px;">
                      <span class="price-display">{{ formatCurrency(item.price) }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="col s12 m2 hide-on-small-only"></div>

            <div class="col s12 m5">
              <div class="total-checkout-box">
                <div class="card-panel grey lighten-4">
                  <h4 class="right-align">
                    {{ traduzione('pagina.carrello.totale') }}:
                    <span class="green-text text-accent-4">
                      {{ formatCurrency(cartTotal) }}
                    </span>
                  </h4>

                  <div id="paypal-button-container">
                    <p class="center-align" v-if="cartTotal > 0 && !paypalScriptLoaded">
                      <img src="@/assets/img/icons/loading.gif" class="loading" />
                    </p>
                  </div>

                  <div class="paypal-info-box" style="margin-top: 20px; padding: 10px 0;">
                    <p class="term-pay">
                      <i class="material-icons tiny green-text text-accent-4">security</i>
                      **{{ traduzione('pagina.pagamento.paypal') }}**
                      <br>
                      {{ traduzione('pagina.pagamento.paypal.001') }}
                    </p>

                    <p class="term-pay">
                      <i class="material-icons tiny green-text text-accent-4">check_circle</i>
                      ** {{ traduzione('pagina.pagamento.paypal.002') }}:** <br />

                      <span
                        v-html="frasePaypalProtection('pagina.pagamento.paypal.003', 'https://www.paypal.com/it/webapps/mpp/paypal-safety-and-security')">
                      </span>
                    </p>

                    <p class="term-pay">
                      <i class="material-icons tiny grey-text">info</i>
                      **{{ traduzione('pagina.pagamento.paypal.005') }}:** <br />

                      <span
                        v-html="frasePaypalProtectiondue('pagina.pagamento.paypal.004', paypalLegalUrl, 'https://www.paypal.com/it/legalhub/paypal/useragreement-full?locale.x=' + currentLocale.replace('-', '_'), 'https://www.paypal.com/it/digital-wallet/paypal-consumer-fees')"></span>
                    </p>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import translationStore from '@/store/translations'
import axios from 'axios'
import useAuthStore from '@/store/authStore.js'
import toast from '@/services/toast.js'
import loadingStore from '@/store/loading'

// Client ID non sensibile necessaria SOLO per il caricamento dell'SDK.
const PAYPAL_CLIENT_ID_SDK = 'Abm_vkJdf8tQsUWwdAiXdCHgfstS9-p3Hll3Dz7WIeIRRexOyZjKW2i1jCeQmls-h0Ey0RIZGcRzKRjE'

export default {
  name: 'CartView',
  data () {
    return {
      cartItems: [],
      paypalScriptLoaded: false,
      useAuthStore: useAuthStore,
      toast: toast,
      pageNoitem: true,
      // Variabile per il conto alla rovescia
      countdown: 3
    }
  },
  computed: {
    traduzione () {
      return translationStore.getters.traduzione
    },
    currentLocale () {
      const locale = translationStore.state.linguaCorrente || 'it-IT'
      return locale.replace('_', '-')
    },

    // PROPRIETÀ COMPUTATA: URL base legale dinamica (corretta)
    paypalLegalUrl () {
      const baseUrl = 'https://www.paypal.com/it/legalhub/paypal/useragreement-full?locale.x='
      const localeParam = this.currentLocale.replace('-', '_')
      return `${baseUrl}${localeParam}`
    },

    cartTotal () {
      return this.cartItems.reduce((total, item) => total + item.price, 0)
    },

    user () {
      return this.useAuthStore.getters.userInfo
    },

    currentUser () {
      const user = this.user
      return {
        uid: user?.uid
      }
    },

    translationStore () {
      return translationStore
    }
  },
  methods: {
    /**
     * Metodo: Gestisce la sostituzione dei placeholder {0} e {1} (link singolo).
     */
    frasePaypalProtection (key, url) {
      const translatedText = this.traduzione(key)
      return translatedText
        .replaceAll('{0}', `<a href="${url}" target="_blank" rel="noopener noreferrer">`)
        .replaceAll('{1}', '</a>')
    },

    /**
     * Metodo: Gestisce la sostituzione dei placeholder {0}, {1} e {2} (due link).
     */
    frasePaypalProtectiondue (key, url1, url2) {
      const translatedText = this.traduzione(key)
      const output = translatedText
        .replaceAll('{0}', `<a href="${url1}" target="_blank" rel="noopener noreferrer">`)
        .replaceAll('{1}', '</a>')
      return output
        .replaceAll('{2}', `<a href="${url2}" target="_blank" rel="noopener noreferrer">`)
    },

    /**
     * Metodo: Gestisce il conto alla rovescia e il reindirizzamento.
     */
    startRedirectCountdown () {
      this.countdown = 3
      const interval = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(interval)
          // Reindirizzamento alla pagina degli eventi
          this.pageNoitem = true
          this.$router.push('/list-events')
        }
      }, 1000)
    },

    formatCurrency (value) {
      return new Intl.NumberFormat(this.currentLocale, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      }).format(value)
    },

    getTypeSuffix (fullName) {
      if (typeof fullName !== 'string') return ''
      const parts = fullName.split('.')
      return parts.length > 1 ? parts[parts.length - 1] : fullName
    },

    loadCart () {
      try {
        const items = JSON.parse(localStorage.getItem('listitem') || '[]')
        this.cartItems = items
      } catch (e) {
        this.cartItems = []
      }
    },

    removeItem (uid) {
      this.cartItems = this.cartItems.filter(item => item.uid !== uid)
      localStorage.setItem('listitem', JSON.stringify(this.cartItems))
      window.dispatchEvent(new Event('storage')) // Aggiorna il badge nell'header
    },

    handleStorageChange (event) {
      if (event.key === 'listitem' || !event.key) {
        this.loadCart()
      }
    },

    loadPayPalScript () {
      loadingStore.commit('setLoading', true)
      if (this.paypalScriptLoaded) {
        this.renderPayPalButton()
        return
      }

      if (document.querySelector(`script[src*="${PAYPAL_CLIENT_ID_SDK}"]`)) {
        this.paypalScriptLoaded = true
        this.renderPayPalButton()
        return
      }

      const script = document.createElement('script')
      script.src = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID_SDK}&currency=EUR`

      script.onload = () => {
        this.paypalScriptLoaded = true
        this.$nextTick(() => {
          this.renderPayPalButton()
        })
      }
      script.onerror = () => {
        console.error('Errore nel caricamento dello script PayPal.')
      }

      document.head.appendChild(script)
      loadingStore.commit('setLoading', false)
    },

    /**
     * Inizializza e renderizza i pulsanti di PayPal.
     */
    renderPayPalButton () {
      if (typeof window.paypal === 'undefined' || this.cartTotal <= 0) {
        const container = document.getElementById('paypal-button-container')
        if (container) container.innerHTML = ''
        return
      }

      const container = document.getElementById('paypal-button-container')
      if (!container) {
        return
      }

      container.innerHTML = ''
      const currentUserId = this.currentUser.uid

      window.paypal.Buttons({
        // 1. Crea l'ordine

        createOrder: (data, actions) => {
          const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

          return axios.post('/ajax/create-order.php?control=' + session, {
            items: this.cartItems,
            total: this.cartTotal.toFixed(2),
            uid: currentUserId
          })
            .then(response => response.data.id)
            .catch(error => { throw error })
        },

        // 2. Cattura l'ordine
        onApprove: (data, actions) => {
          const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          return axios.post('/ajax/capture-order.php?control=' + session, {
            orderID: data.orderID
          })
            .then(response => {
              if (response.data.status === 'COMPLETED') {
                const addCar = this.traduzione('pagina.pagamento.paypal.006')
                this.toast.createStampToast('thumb_up', addCar, 'toast-green')
                localStorage.removeItem('listitem')
                window.dispatchEvent(new Event('storage'))

                // Imposta a falso per mostrare il messaggio di successo e avvia il countdown
                this.pageNoitem = false
                this.startRedirectCountdown()
              } else {
                const addCar = this.traduzione('pagina.pagamento.paypal.007')
                this.toast.createStampToast('thumb_down', addCar, 'toast-red')
              }
            })
            .catch(error => {
              const addCar = this.traduzione('pagina.pagamento.paypal.008')
              this.toast.createStampToast('thumb_down', addCar, 'toast-red')
              throw error
            })
        },

        onError: (err) => {
          console.error('Errore generico SDK PayPal:', err)
          const addCar = this.traduzione('pagina.pagamento.paypal.008')
          this.toast.createStampToast('thumb_up', addCar, 'toast-red')
        }
      }).render('#paypal-button-container')
    }
  },

  watch: {
    cartTotal: {
      handler (newTotal) {
        if (newTotal > 0) {
          this.loadPayPalScript()
        } else {
          const container = document.getElementById('paypal-button-container')
          if (container) container.innerHTML = ''
        }
      },
      immediate: true
    }
  },

  created () {
    this.loadCart()
    window.addEventListener('storage', this.handleStorageChange)
    loadingStore.commit('setLoading', false)
  },
  mounted () {
    loadingStore.commit('setLoading', false)
  },

  beforeDestroy () {
    // Resetta lo stato quando si lascia la pagina (importante se l'utente torna indietro)
    this.pageNoitem = true
    window.removeEventListener('storage', this.handleStorageChange)
  }
}
</script>

<style scoped>
/* STILI ESISTENTI */
.corpo-pagina {
  padding-top: 20px;
  padding-bottom: 40px;
}

.row-text {
  margin-bottom: 20px;
}

h4 {
  color: black !important;
  font-size: 2rem;
}

.divider {
  margin-bottom: 20px;
}

.empty-cart-message {
  padding: 50px 0;
}

.empty-cart-message .material-icons {
  font-size: 5rem;
  margin-bottom: 20px;
}

/* Stili per la lista degli articoli */
.collection-header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
}
.collection-header h4 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 400;
}
.cart-item-list {
  padding: 15px 20px !important;
  border-bottom: 1px solid #e0e0e0;
}
.item-name {
  font-weight: 500;
  font-size: 1.3rem;
  margin-top: 0;
  margin-bottom: 5px;
}
.item-quantity {
  font-size: 0.9rem;
  color: #757575;
}
.item-price .price-display {
  font-weight: bold;
  font-size: 1.4rem;
  color: #4CAF50;
}
.remove-btn {
  font-size: 1.5rem;
  transition: transform 0.2s;
}
.remove-btn:hover {
  transform: scale(1.1);
}

/* Stili per il blocco di checkout e il totale */
.total-checkout-box .card-panel {
  padding: 20px;
  border-radius: 8px;
}

/* Stile per il contenitore di PayPal */
#paypal-button-container {
    width: 50%;
    margin: auto;
    padding-top: 50px;
    padding-bottom: 40px;
}

/* Layout affiancato */
@media only screen and (min-width: 601px) {
  .cart-checkout-layout {
    display: flex;
    margin-bottom: 0;
  }

  /* Aggiunge un po' di spazio tra la lista e il blocco di checkout */
  .cart-checkout-layout > .col.m5:first-child {
      padding-right: 1.5rem;
  }
}

/* Adattamenti per mobile */
@media only screen and (max-width: 600px) {
  .item-name {
    font-size: 1.1rem;
  }

  .item-price .price-display {
    font-size: 1.2rem;
  }

  /* Aggiunge spazio sopra il blocco di checkout su mobile */
  .total-checkout-box {
    margin-top: 20px;
  }
}
.term-pay{
 font-size: 0.8rem;
 color: rgb(68, 68, 68);
 line-height: normal;
}
</style>
